<template>
  <div class="qyjlyjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="年份">
              <el-date-picker v-model="searchForm.year" type="year" format="yyyy" value-format="yyyy" :clearable="false" placeholder="请选择年份" @change="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              <el-button icon="el-icon-plus" type="primary" @click="addData">新增</el-button>
              <el-button v-if="config.showAreaTarget" icon="el-icon-view" type="info" @click="showAreaTargetTable">隐藏业绩目标表</el-button>
              <el-button v-else icon="el-icon-view" type="primary" plain @click="showAreaTargetTable">显示业绩目标表</el-button>
            </el-form-item>
            <el-form-item>
              <div style="margin: 0 10px; color: red;">统计金额单位：<span style="font-weight: bold;">{{ unit }}</span></div>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-refresh" @click="changeUnit">
                切换为：{{ unit == '万元' ? '元' : '万元' }}
              </el-button>
            </el-form-item>
          </el-form>

          <div class="card-content" v-show="config.showAreaTarget">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; text-align: center;">
                  {{ searchForm.year }}年度-区域经理业绩目标表 ({{ unit }})
                </div>
                <el-table :data="areaTargetList" v-loading="loading" stripe style="width: 100%;">
                  <el-table-column label="区域经理" prop="name" min-width="100" align="center" fixed show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    v-for="value in monthList"
                    :key="value"
                    :label="value + '月'"
                    min-width="85"
                    align="center">
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row[value]) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="合计" prop="total" min-width="95" fixed="right" align="center">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ parseNumUnit(scope.row.total) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="180" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-edit" @click.stop="editData(scope.row)">编辑</el-button>
                      <el-button size="mini" icon="el-icon-delete" @click.stop="delData(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <div class="card-content" :style="config.showAreaTarget ? 'margin-top: 40px;' : ''">
            <el-row>
              <el-col :span="24" v-loading="statLoading">
                <div
                  style="position: relative; background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; display: flex; align-items: center; justify-content: center;">
                  {{ searchForm.year }}年度-区域经理业绩分析 ({{ unit }})
                  <el-tooltip content="区域经理业绩说明：已过预付款订单的客户承担金额总和" placement="top">
                    <i class="header-icon el-icon-info" style="color: #606266; font-size: 17px; margin-left: 10px;"></i>
                  </el-tooltip>
                  <div style="position: absolute; right: 10px;">
                    <el-popover
                      placement="right"
                      width="160"
                      trigger="click">
                      <div class="popover-custom">
                        <el-checkbox-group v-model="config.statTableColumn" size="mini" @change="changeColumn">
                          <el-checkbox label="序号" disabled></el-checkbox>
                          <el-checkbox label="区域经理" disabled></el-checkbox>
                          <el-checkbox label="年度目标"></el-checkbox>
                          <el-checkbox label="累计目标"></el-checkbox>
                          <el-checkbox label="累计已完成"></el-checkbox>
                          <el-checkbox label="累计剩余"></el-checkbox>
                          <el-checkbox label="累计目标完成率"></el-checkbox>
                          <el-checkbox label="年度剩余"></el-checkbox>
                          <el-checkbox label="年度完成率"></el-checkbox>
                          <el-checkbox label="年度下单金额"></el-checkbox>
                          <el-checkbox label="冲业绩金额x2"></el-checkbox>
                          <el-checkbox label="冲业绩下单"></el-checkbox>
                          <el-checkbox label="冲业绩差额"></el-checkbox>
                          <el-checkbox label="本月目标"></el-checkbox>
                          <el-checkbox label="本月已完成"></el-checkbox>
                          <el-checkbox label="本月剩余"></el-checkbox>
                          <el-checkbox label="本月完成率"></el-checkbox>
                          <el-checkbox label="月度下单金额"></el-checkbox>
                          <el-checkbox label="月度冲业绩金额x2"></el-checkbox>
                          <el-checkbox label="上月冲业绩金额x2"></el-checkbox>
                          <el-checkbox label="月度冲业绩下单"></el-checkbox>
                          <el-checkbox label="月度冲业绩差额"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <el-button slot="reference" icon="el-icon-setting" size="small">配置表格列</el-button>
                    </el-popover>
                  </div>
                </div>
                <el-table :data="statData" border :row-class-name="rowClassName" :cell-class-name="cellClassName" :header-cell-class-name="cellClassName" style="width: 100%;">
                  <el-table-column label="序号" type="index" width="60" align="center" fixed></el-table-column>
                  <el-table-column v-if="config.statTableColumn.includes('区域经理')" label="区域经理" prop="name" min-width="110" align="center" fixed show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="config.statTableColumn.includes('年度目标') || config.statTableColumn.includes('累计目标') || config.statTableColumn.includes('累计已完成') || config.statTableColumn.includes('年度完成率')" :label="searchForm.year + '年度目标'" prop="group1" align="center">
                    <el-table-column v-if="config.statTableColumn.includes('年度目标')" label="年度目标" prop="yearTargetMoney" min-width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '全年的业绩目标总和'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">年度目标</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.yearTargetMoney) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('累计目标')" label="累计目标" prop="sumTargetMoney" min-width="120" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年1月至' + searchForm.month + '月的业绩目标总和'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">累计目标</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.sumTargetMoney) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('累计已完成')" label="累计已完成" prop="yearMoney" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年已完成的业绩总和(含冲业绩)'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">累计已完成</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.yearMoney) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('累计剩余')" label="累计剩余" prop="sumBalance" min-width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'累计剩余目标金额 = 累计目标金额 - 累计已完成金额'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">累计剩余</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(Math.max(0, scope.row.sumTargetMoney - scope.row.yearMoney)) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('累计目标完成率')" label="累计目标完成率" prop="sumPct" min-width="130" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'累计目标完成率 = ' + searchForm.year + '年已完成的业绩总和(含冲业绩) / ' + searchForm.year + '年1月至' + searchForm.month + '月的业绩目标总和'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">累计目标完成率</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('年度剩余')" label="年度剩余" prop="yearBalance" min-width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'年度剩余目标金额 = 年度目标金额 - 累计已完成金额'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">年度剩余</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(Math.max(0, scope.row.yearTargetMoney - scope.row.yearMoney)) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('年度完成率')" label="年度完成率" prop="yearPct" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'年度完成率 = ' + searchForm.year + '年已完成的业绩总和 / 全年的业绩目标总和'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">年度完成率</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('年度下单金额')" label="年度下单金额" prop="yearXd" min-width="120" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年已完成的订单业绩总和(不含冲业绩)'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">年度下单金额</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.yearXd) }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column v-if="config.statTableColumn.includes('冲业绩金额x2') || config.statTableColumn.includes('冲业绩下单') || config.statTableColumn.includes('冲业绩差额')" :label="searchForm.year + '年冲业绩'" prop="group2" align="center">
                    <el-table-column v-if="config.statTableColumn.includes('冲业绩金额x2')" label="冲业绩金额x2" prop="yearCyj" min-width="120" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年1月至' + searchForm.month + '月的冲业绩金额X2'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">冲业绩金额x2</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.yearCyj) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('冲业绩下单')" label="冲业绩下单" prop="yearCyjXd" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年1月至' + searchForm.month + '月的冲业绩下单'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">冲业绩下单</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.yearCyjXd) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('冲业绩差额')" label="冲业绩差额" prop="yearYj" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年1月至' + searchForm.month + '月的冲业绩差额'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">冲业绩差额</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.yearYj) }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column v-if="config.statTableColumn.includes('本月目标') || config.statTableColumn.includes('本月已完成') || config.statTableColumn.includes('本月完成率') || config.statTableColumn.includes('本月下单金额')" :label="searchForm.month + '月目标'" prop="group3" align="center">
                    <el-table-column v-if="config.statTableColumn.includes('本月目标')" label="本月目标" prop="monthTargetMoney" min-width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'区域经理本月的业绩目标'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">本月目标</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.monthTargetMoney) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('本月已完成')" label="本月已完成" prop="monthMoney" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'区域经理本月已完成的业绩总和(含冲业绩)'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">本月已完成</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.monthMoney) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('本月剩余')" label="本月剩余" prop="monthBalance" min-width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'本月剩余目标金额 = 本月目标金额 - 本月已完成金额'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">本月剩余</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(Math.max(0, scope.row.monthTargetMoney - scope.row.monthMoney)) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('本月完成率')" label="本月完成率" prop="monthPct" min-width="110" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'本月完成率 = 本月已完成业绩总和(含冲业绩) / 本月目标业绩'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">本月完成率</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('月度下单金额')" label="月度下单金额" prop="monthXd" min-width="120" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年' + searchForm.month + '月已完成的订单业绩总和(不含冲业绩)'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">月度下单金额</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthXd) }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column v-if="config.statTableColumn.includes('月度冲业绩金额x2') || config.statTableColumn.includes('月度冲业绩下单') || config.statTableColumn.includes('月度冲业绩差额') || config.statTableColumn.includes('上月冲业绩金额x2')" :label="searchForm.year + '年' + searchForm.month + '月冲业绩'" prop="group4" align="center">
                    <el-table-column v-if="config.statTableColumn.includes('月度冲业绩金额x2')" label="月度冲业绩金额x2" prop="monthCyj" min-width="150" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年' + searchForm.month + '月的冲业绩金额X2'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">月度冲业绩金额x2</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthCyj) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('上月冲业绩金额x2')" label="上月冲业绩金额x2" prop="monthCyj" min-width="150" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="'上月的冲业绩金额X2'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">上月冲业绩金额x2</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.lastMonthCyj) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('月度冲业绩下单')" label="月度冲业绩下单" prop="monthCyjXd" min-width="130" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年' + searchForm.month + '月的冲业绩下单'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">月度冲业绩下单</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthCyjXd) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="config.statTableColumn.includes('月度冲业绩差额')" label="月度冲业绩差额" prop="monthYj" min-width="130" align="center">
                      <template slot="header" slot-scope="scope">
                        <el-tooltip :content="searchForm.year + '年' + searchForm.month + '月的冲业绩差额 = 月度冲业绩下单 + 月度冲业绩金额x2 - 上月冲业绩金额x2'" placement="top">
                          <div style="display: flex; align-items: center; justify-content: center;">
                            <span style="margin-right: 2px;">月度冲业绩差额</span>
                            <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                          </div>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.monthYj) }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px;">
            <el-row>
              <el-col :span="24">
                <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                  <el-form-item label="月份">
                    <el-date-picker v-model="searchForm.year_month" type="month" format="yyyy-MM" value-format="yyyy-MM" :clearable="false" placeholder="请选择年月" @change="Search2" />
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" @click="Search2">搜索</el-button>
                  </el-form-item>
                  <el-form-item>
                    <div style="margin: 0 10px; color: red;">统计金额单位：<span style="font-weight: bold;">{{ unit }}</span></div>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-refresh" @click="changeUnit">
                      切换为：{{ unit == '万元' ? '元' : '万元' }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="24" v-loading="monthLoading">
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; display: flex; align-items: center; justify-content: center;">
                  {{ searchForm.year_month.replace('-', '年') }}月全国下单总业绩详情 ({{ unit }})
                </div>
                <el-table :data="monthData" border :row-class-name="rowClassName" style="width: 100%">
                  <el-table-column prop="name" label="区域经理" align="center" min-width="65"></el-table-column>
                  <el-table-column :label="'月度业绩详情'" align="center">
                    <el-table-column prop="monthMoneyStr" label="下单金额" align="center">
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail2(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthCyjMoneyStr" label="冲业绩金额x2" align="center">
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail2(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthCyjMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="lastMonthCyjMoneyStr" label="上月冲业绩金额x2" align="center">
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail2(scope.row, scope.column)">{{ parseNumUnit(scope.row.lastMonthCyjMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthCyjXdMoneyStr" label="本月冲业绩下单" align="center">
                      <template slot-scope="scope">
                        <span class="see-text" @click="showDetail2(scope.row, scope.column)">{{ parseNumUnit(scope.row.monthCyjXdMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthYjMoneyStr" label="冲业绩差额" align="center">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.monthYjMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthTotalMoneyStr" label="总业绩(下单金额+冲业绩金额x2+冲业绩差额)" align="center">
                      <template slot-scope="scope">
                        <span>{{ parseNumUnit(scope.row.monthTotalMoneyStr) }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>

      <el-col class="card" style="margin-top: 20px;">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm2" @submit.native.prevent>
            <el-form-item label="年份">
              <el-date-picker v-model="searchForm2.year" type="year" format="yyyy" value-format="yyyy" :clearable="false" placeholder="请选择年份" @change="yjSearch" />
            </el-form-item>
            <el-form-item>
              <el-button v-if="!dealerTarget.id" icon="el-icon-plus" type="primary" @click="addData2">新增目标</el-button>
              <el-button v-if="dealerTarget.id" icon="el-icon-edit" type="warning" @click="editData2(dealerTarget)">编辑目标</el-button>
              <el-button icon="el-icon-plus" type="primary" @click="addData3">新增合同</el-button>
              <!-- <el-button v-if="config.showAreaTarget" icon="el-icon-view" type="info" @click="showAreaTargetTable">隐藏业绩目标表</el-button> -->
              <!-- <el-button v-else icon="el-icon-view" type="primary" plain @click="showAreaTargetTable">显示业绩目标表</el-button> -->
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading2">
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; text-align: center;">
                  {{ searchForm2.year }}年度-经销商业绩月度目标比例配置
                </div>
                <el-table :data="dealerTargetList" v-loading="loading2" stripe style="width: 100%;">
                  <!-- <el-table-column label="年份" prop="year" min-width="80" align="center" fixed></el-table-column> -->
                  <el-table-column
                    v-for="value in monthList"
                    :key="value"
                    :label="value + '月'"
                    min-width="75"
                    align="center">
                    <template slot-scope="scope">
                      <span>{{ (scope.row['ratio' + value] || 0) * 100 }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="file" label="营销政策文件" min-width="150" align="center">
                    <template slot-scope="scope">
                      <span :style="scope.row.fileObj.id ? 'cursor: pointer; color: #409EFF;' : 'color: #d9d9d9;'" @click="downFile(scope.row.fileObj)">
                        {{ scope.row.fileObj.name || '--' }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100" fixed="right" align="center">
                    <template slot-scope="scope">
                      <!-- <el-button size="mini" icon="el-icon-edit" @click.stop="editData2(scope.row)">编辑</el-button> -->
                      <el-button size="mini" icon="el-icon-delete" @click.stop="delData2(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>

          <el-form style="margin-top: 40px;" :inline="true" size="small" :model="searchForm2" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm2.search" placeholder="关键字搜索" @keyup.enter.native="yjSearch"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="yjSearch">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <div style="margin: 0 10px; color: red;">统计金额单位：<span style="font-weight: bold;">{{ unit }}</span></div>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-refresh" @click="changeUnit">
                切换为：{{ unit == '万元' ? '元' : '万元' }}
              </el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading3">
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; display: flex; align-items: center; justify-content: center;">
                  {{ searchForm2.year }}年经销商合同列表 ({{ unit }})
                </div>
                <el-table :data="dealerContractList" style="width: 100%">
                  <el-table-column prop="dealerName" label="经销商" align="center" fixed="left" min-width="140"></el-table-column>
                  <el-table-column prop="target" label="年度目标" align="center" min-width="100">
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.target) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="real" label="实际完成金额" align="center" min-width="110">
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.real) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="imgs" label="合同图片" min-width="80" align="center">
                    <template slot-scope="scope">
                      <span :style="(scope.row.imgs && scope.row.imgs.length > 0) ? 'cursor: pointer; color: #409EFF;' : 'color: #d9d9d9;'" @click="showImgOrFile('img', scope.row)">
                        {{ (scope.row.imgs && scope.row.imgs.length > 0) ? '查看图片' : '--' }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="files" label="合同文件" min-width="80" align="center">
                    <template slot-scope="scope">
                      <el-popover
                        placement="top"
                        width="400"
                        :disabled="!scope.row.files || scope.row.files.length == 0"
                        trigger="click">
                        <div v-if="scope.row.files && scope.row.files.length > 0" style="display: flex; flex-direction: column;">
                          <h3 style="margin: 5px;">文件列表</h3>
                          <div v-for="(file, idx) in scope.row.files" :key="file.id" style="padding: 5px;">
                            <span style="font-weight: bold;">{{ idx+ 1 }}、</span>
                            <span style="cursor: pointer; color: #409EFF;" @click="downFile(file)">
                              {{ file.name }}
                            </span>
                          </div>
                        </div>
                        <span slot="reference" :style="(scope.row.files && scope.row.files.length > 0) ? 'cursor: pointer; color: #409EFF;' : 'color: #d9d9d9;'">
                          {{ (scope.row.files && scope.row.files.length > 0) ? '查看文件' : '--' }}
                        </span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column label="操作" width="180" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-edit" @click.stop="editData3(scope.row)">编辑</el-button>
                      <el-button size="mini" icon="el-icon-delete" @click.stop="delData3(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-show="page3.total > 0" style="margin-top:10px;" background
                  @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="page3.currentPage"
                  :page-sizes="[10, 20, 50]" :page-size="page3.pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="page3.total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

          <div class="card-content" style="margin-top: 40px;">
            <el-row>
              <el-col :span="24">
                <el-form :inline="true" size="small" :model="searchForm2" @submit.native.prevent>
                  <el-form-item label="月份">
                    <el-date-picker v-model="searchForm2.year_month" type="month" format="yyyy-MM" value-format="yyyy-MM" :clearable="false" placeholder="请选择年月" @change="yjSearch2" />
                  </el-form-item>
                  <el-form-item label="搜索关键字">
                    <el-input v-model="searchForm2.search2" placeholder="关键字搜索" @keyup.enter.native="yjSearch2"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" @click="yjSearch2">搜索</el-button>
                  </el-form-item>
                  <el-form-item>
                    <div style="margin: 0 10px; color: red;">统计金额单位：<span style="font-weight: bold;">{{ unit }}</span></div>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-refresh" @click="changeUnit">
                      切换为：{{ unit == '万元' ? '元' : '万元' }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="24" v-loading="loading4">
                <div
                  style="background-color: #f5f7fa; border: 1px solid #EBEEF5; border-bottom: none; padding: 12px; color: #303133; font-size: 17px; font-weight: bold; display: flex; align-items: center; justify-content: center;">
                  {{ searchForm2.year_month.replace('-', '年') }}月经销商月度业绩分析 ({{ unit }})
                </div>
                <el-table :data="yjMonthList" style="width: 100%">
                  <el-table-column prop="dealerName" label="经销商" align="center" fixed="left" min-width="120" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column prop="year" label="年月" width="90" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.year }}年{{ scope.row.month }}月</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="moneyTarget" label="业绩目标" min-width="90" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="业绩目标金额 = 年度目标 * 当月占比(含冲业绩)" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">业绩目标</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyTarget) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyXd" label="下单总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="非工程非冲业绩单（包含家庭单和展厅单）客户承担总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">下单总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyXd) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyXdAlum" label="铝材下单总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="非工程非冲业绩单（包含家庭单和展厅单）铝材总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">铝材下单总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyXdAlum) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyXdAccessory" label="配件下单总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="非工程非冲业绩单（包含家庭单和展厅单）配件总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">配件下单总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyXdAccessory) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyShow" label="展厅单总金额" min-width="100" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="展厅单客户承担总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">展厅单总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyShow) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyShowAlum" label="展厅单铝材总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="展厅单铝材总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">展厅单铝材总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyShowAlum) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyShowAccessory" label="展厅单配件总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="展厅单配件总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">展厅单配件总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyShowAccessory) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyCyj" label="当月冲业绩金额x2" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="当月冲业绩金额x2" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">当月冲业绩金额x2</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyCyj) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyCyjLast" label="上月冲业绩金额x2" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="上月冲业绩金额x2" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">上月冲业绩金额x2</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyCyjLast) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyCyjXd" label="冲业绩下单金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="冲业绩订单客户承担总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">冲业绩下单金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyCyjXd) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyCyjXdAlum" label="冲业绩铝材总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="冲业绩订单铝材总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">冲业绩铝材总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyCyjXdAlum) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyCyjXdAccessory" label="冲业绩配件总金额" min-width="110" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="冲业绩订单配件总金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">冲业绩配件总金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyCyjXdAccessory) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyEffect" label="可返点金额" min-width="110" fixed="right" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="可参与计算返点的金额" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">可返点金额</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyEffect) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moneyTotal" label="总业绩" min-width="100" fixed="right" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip content="总业绩 = 下单总金额 + 当月冲业绩金额x2" placement="top">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <span style="margin-right: 2px;">总业绩</span>
                          <i class="header-icon el-icon-info" style="color: #606266; font-size: 15px;"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span>{{ parseNumUnit(scope.row.moneyTotal) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-show="page4.total > 0" style="margin-top:10px;" background
                  @size-change="handleSizeChange4" @current-change="handleCurrentChange4" :current-page="page4.currentPage"
                  :page-sizes="[10, 20, 50]" :page-size="page4.pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="page4.total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" top="30px"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true" :close-on-click-modal="false">
      <div style="padding: 0 20px">
        <el-form ref="editForm" size="small" :model="formData" label-width="80px" :rules="rules">
          <el-form-item label="区域经理" prop="userId">
            <UserSelect v-if="dialogVisible" v-model="formData.userId" :set="formData.userId" :groupid="user.groupid" :userid="user.dUserid"
              :disabled="formData.type === 'edit'" @change="changeUser">
            </UserSelect>
          </el-form-item>
          <el-form-item v-for="value in monthList" :key="value" :label="value + '月目标'" :prop="'jsonForm.' + value">
            <el-input v-model="formData.jsonForm[value]" :key="value" style="width: 200px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button :loading="formLoading" type="primary" @click="submitForm('editForm')">立即提交</el-button>
            <el-button @click="dialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle2" :visible.sync="dialogVisible2" width="600px" top="30px"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true" :close-on-click-modal="false">
      <div style="padding: 0 20px">
        <el-form ref="editForm2" size="small" :model="formData2" label-width="90px" :rules="rules2">
          <el-form-item v-for="value in monthList" :key="value" :label="value + '月比例'" :prop="'jsonForm.ratio' + value">
            <el-input v-model="formData2.jsonForm['ratio' + value]" :key="value" style="width: 130px">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="营销政策文件" prop="fileId">
            <SingleFile v-model="formData2.fileId" :old="[{ ...formData2.file }]" @change="changeFile" />
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button :loading="formLoading2" type="primary" @click="submitForm2('editForm2')">立即提交</el-button>
            <el-button @click="dialogVisible2 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle3" :visible.sync="dialogVisible3" width="600px" top="30px"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true" :close-on-click-modal="false">
      <div v-if="dialogVisible3" style="padding: 0 20px">
        <el-form ref="editForm3" size="small" :model="formData3" label-width="75px" :rules="rules3">
          <el-form-item label="经销商" prop="dealerId">
            <DealerSelect v-model="formData3.dealerId" :dealers="dealerList" :multiple="false"
              :disabled="formData3.type === 'edit'">
            </DealerSelect>
          </el-form-item>
          <el-form-item label="年度目标" prop="target">
            <el-input v-model="formData3.target" style="width: 250px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="'月度目标拆解预览 (元)'" label-width="150px">
          </el-form-item>
          <el-form-item label="" label-width="0px">
            <table class="tcf-detail-table">
              <tr>
                <template v-for="value in 6">
                  <td style="width: 50px; background: #f5f7fa; text-align: center; font-weight: bold;">{{ value }}月</td>
                </template>
              </tr>
              <tr>
                <template v-for="value in 6">
                  <td style="text-align: center;">
                    {{ Math.round(formData3.target * dealerTarget['ratio' + value]) }}
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="value in 6">
                  <td style="width: 50px; background: #f5f7fa; text-align: center; font-weight: bold;">{{ value + 6 }}月</td>
                </template>
              </tr>
              <tr>
                <template v-for="value in 6">
                  <td style="text-align: center;">
                    {{ Math.round(formData3.target * dealerTarget['ratio' + (value + 6)]) }}
                  </td>
                </template>
              </tr>
            </table>
          </el-form-item>
          <el-form-item label="合同图片" prop="imgIds">
            <MultiImg v-model="formData3.imgIds" :limit="9" :size="'sm'" :old="[...formData3.imgs]" @change="multilChangeImg" />
          </el-form-item>
          <el-form-item label="合同文件" prop="fileIds">
            <MultiFile v-model="formData3.fileIds" :old="[...formData3.files]" @change="multilChangeFile" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="formData3.remark" type="textarea" maxlength="300" show-word-limit />
          </el-form-item>
          <el-form-item style="text-align: right;">
            <el-button :loading="formLoading3" type="primary" @click="submitForm3('editForm3')">立即提交</el-button>
            <el-button @click="dialogVisible3 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :title="orderViewTitle" :visible.sync="orderVisible" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div v-if="orderVisible" style="padding:10px 20px" v-loading="orderLoading">
        <el-table
          v-if="orderSearchForm.type && orderSearchForm.type.indexOf('Cyj') > -1 && orderSearchForm.type.indexOf('Xd') === -1"
          :data="orderList"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="500">
          <el-table-column
            label="经销商"
            min-width="130"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="scope.row.dealerName && scope.row.dealerName.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ scope.row.dealerName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="经销商电话" prop="dealerTel" align="center" min-width="120"></el-table-column>
          <el-table-column label="区域经理" prop="areaName" align="center" min-width="100"></el-table-column>
          <!-- <el-table-column label="销售客服" prop="serveName" align="center" min-width="100"></el-table-column> -->
          <el-table-column label="经办人" prop="username" align="center" min-width="100"></el-table-column>
          <el-table-column label="收款时间" prop="receiptTime" align="center" min-width="120"></el-table-column>
          <el-table-column label="收款方式" prop="nature" align="center" min-width="100"></el-table-column>
          <el-table-column label="冲业绩金额" prop="money" align="center" min-width="120"></el-table-column>
          <el-table-column label="收款账号" prop="accountName" align="center" min-width="200"></el-table-column>
          <el-table-column label="收款卡号" prop="accountCard" align="center" min-width="150"></el-table-column>
        </el-table>
        <el-table
          v-else-if="orderSearchForm.type"
          :data="orderList"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="500">
          <el-table-column
            label="订单号"
            width="120"
            align="center"
            fixed
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.ordernum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="110"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.produnum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单类型"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="typeof scope.row.orderType === 'number'">
                <span v-if="scope.row.orderType===0">正单</span>
                <span v-if="scope.row.orderType===1">客改单</span>
                <span v-if="scope.row.orderType===2">增补单</span>
                <span v-if="scope.row.orderType===3">色板单</span>
                <span v-if="scope.row.orderType===4">售后单</span>
              </template>
              <span v-else>{{ scope.row.orderType }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            min-width="130"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="(scope.row.delname || scope.row.dealerName) && (scope.row.delname || scope.row.dealerName).indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ scope.row.delname || scope.row.dealerName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="time" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.time || scope.row.subsistTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="详细地址"
            prop="address"
            min-width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="客户承担" prop="clientcom" align="center" width="100"></el-table-column>
          <el-table-column label="设计师承担" prop="designcom" align="center" width="100"></el-table-column>
          <el-table-column label="工厂承担" prop="factorycom" align="center" width="100"></el-table-column>
          <el-table-column label="其他" prop="other" align="center" width="80"></el-table-column>
          <el-table-column label="更改单金额" prop="changes" align="center" width="100"></el-table-column>
          <el-table-column label="加价" prop="raise" align="center" width="80"></el-table-column>
          <el-table-column label="优惠" prop="best" align="center" width="80"></el-table-column>
          <el-table-column label="退款金额" prop="refund" align="center" width="100"></el-table-column>
          <el-table-column label="已支付" prop="paidfor" align="center" width="80"></el-table-column>
          <el-table-column label="实际金额" prop="amount" align="center" width="100"></el-table-column>
          <el-table-column label="总金额" prop="totalprice" align="center" width="90"></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px;"
          v-if="orderTotal>0"
          background
          @size-change="handleOrderSizeChange"
          @current-change="handleOrderCurrentChange"
          :current-page="orderCurrentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="orderPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="orderTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-image-viewer
      v-if="showImgViewer"
      :on-close="() => showImgViewer = false"
      :url-list="viewImgUrls">
    </el-image-viewer>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    areaTargets,
    addAreaTarget,
    editAreaTarget,
    delAreaTarget,
    areaTargetStatistics,
    areaTargetStatisticDetail,
    areaMonthTargets,
    areaMonthTargetDetail,
    // 经销商业绩目标/合同
    addYjTarget,
    editYjTarget,
    delYjTarget,
    yjTargets,
    addYjContract,
    editYjContract,
    delYjContract,
    yjContracts,
    yjMonth
  } from '@/api/erp'

  import {
    getDealerList
  } from '@/api/work'

  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import GraphicsChart from '@/components/Charts/GraphicsChart'
  import UserSelect from '@/components/UserSelect'
  import DealerSelect from '@/components/DealerSelect';
  import SingleFile from '@/components/upload/SingleFile'
  import MultiFile from '@/components/upload/MultiFile'
  import MultiImg from '@/components/upload/MultiImg'

  export default {
    name: 'qyjlyjfx',
    components: {
      ElImageViewer,
      GraphicsChart,
      UserSelect,
      DealerSelect,
      SingleFile,
      MultiFile,
      MultiImg
    },
    data() {
      let monthList = []
      for (let i = 1; i <= 12; i++) {
        monthList.push(`${i}`)
      }
      return {
        monthList,

        config: {
          showAreaTarget: true,
          statTableColumn: [
            '序号',
            '区域经理',
            '年度目标',
            '累计目标',
            '累计已完成',
            '累计剩余',
            '累计目标完成率',
            '年度剩余',
            '年度完成率',
            '年度下单金额',
            '冲业绩金额x2',
            '冲业绩下单',
            '冲业绩差额',
            '本月目标',
            '本月已完成',
            '本月剩余',
            '本月完成率',
            '月度下单金额',
            '月度冲业绩金额x2',
            '上月冲业绩金额x2',
            '月度冲业绩下单',
            '月度冲业绩差额',
          ], // 表格列显隐配置
          unit: '元'
        },

        searchForm: {
          year: '',
          month: '',
          year_month: ''
        },
        loading: false,
        areaTargetList: [],

        statLoading: false,
        statData: [],

        monthLoading: false,
        monthData: [],

        searchForm2: {
          year: '',
          year_month: '',
          search: '',
          search2: ''
        },
        loading2: false,
        dealerTargetList: [],
        dealerTarget: {}, // 当前年份的目标对象
        loading3: false,
        dealerContractList: [],
        page3: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        loading4: false,
        yjMonthList: [],
        page4: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

        unit: '元',

        dialogTitle: '',
        dialogVisible: false,
        formLoading: false,
        formData: {
          type: 'add',
          year: '',
          userId: null,
          name: '',
          jsonForm: {},
          jsonStr: ''
        },
        rules: {
          userId: [{ required: true, message: '请选择区域经理', trigger: 'change' }],
          ...monthList.reduce((rules, month) => {
            rules[`jsonForm.${month}`] = [{ required: true, message: `请输入${month}月目标`, trigger: 'blur' }]
            return rules
          }, {})
        },

        dealerList: [],

        dialogTitle2: '',
        dialogVisible2: false,
        formLoading2: false,
        formData2: {
          type: 'add',
          year: '',
          file: {},
          fileId: '',
          jsonForm: {}
        },
        rules2: {
          ...monthList.reduce((rules, month) => {
            rules[`jsonForm.ratio${month}`] = [{ required: true, message: `请输入${month}月比例`, trigger: 'blur' }]
            return rules
          }, {})
        },

        dialogTitle3: '',
        dialogVisible3: false,
        formLoading3: false,
        formData3: {
          type: 'add',
          year: '',
          dealerId: null,
          target: 0,
        },
        rules3: {
          target: [{ required: true, message: '请输入年度目标金额', trigger: 'blur' }]
        },

        showImgViewer: false,
        viewImgUrls: [],

        orderViewTitle: '',
        orderLoading: false,
        orderVisible: false,
        orderList: [],
        orderSearchForm: {},
        orderCurrentPage: 1,
        orderPageSize: 20,
        orderTotal: 0,

        circleOption: {},
      }
    },
    computed: {
      user: getUser
    },
    created() {
      this.initConfig();

      const myDate = new Date()
      this.searchForm.year = myDate.getFullYear() + ''
      this.searchForm2.year = myDate.getFullYear() + ''
      const m = myDate.getMonth() + 1
      this.searchForm.year_month = myDate.getFullYear() + '-' + (m < 9 ? '0' + m : m)
      this.searchForm2.year_month = myDate.getFullYear() + '-' + (m < 9 ? '0' + m : m)

      this.Search()
      this.Search2()
      this.yjSearch()
      this.yjSearch2()

      this.loadDealers()
    },
    methods: {
      initConfig() {
        const config = localStorage.getItem('qyjlyjfx_config');
        if (config) {
          this.config = JSON.parse(config)
          this.unit = this.config.unit || '元'
        }
      },

      showAreaTargetTable() {
        this.config.showAreaTarget = !this.config.showAreaTarget
        localStorage.setItem('qyjlyjfx_config', JSON.stringify(this.config))
      },

      changeColumn(value) {
        localStorage.setItem('qyjlyjfx_config', JSON.stringify(this.config))
      },

      changeUnit() {
        this.unit = this.unit == '万元' ? '元' : '万元'
        this.config.unit = this.unit
        localStorage.setItem('qyjlyjfx_config', JSON.stringify(this.config))
      },
      parseNumUnit(num = 0) {
        // 万元向下取整
        return this.unit == '万元' ? Math.floor(num / 100) / 100 : num;
      },

      loadDealers() {
        getDealerList({
          page: 1,
          limit: 999
        }).then(response => {
          let data = response.data || []
          this.dealerList = data
        }).catch(() => {
        })
      },

      Search() {
        const myDate = new Date()
        if (this.searchForm.year == myDate.getFullYear()) {
          this.searchForm.month = (myDate.getMonth() + 1) + ''
        } else {
          // 如果选择的年份不是当前年份，则默认选择12月
          this.searchForm.month = '12'
        }
        this.getData()
        this.getStatistics()
      },
      Search2() {
        this.getMonthTarget()
      },

      yjSearch() {
        this.getYjTarget()
        this.page3.currentPage = 1
        this.getYjContract()
      },
      yjSearch2() {
        this.page4.currentPage = 1
        this.getYjMonth()
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          year: this.searchForm.year,
        }

        this.loading = true
        areaTargets(data).then(response => {
          const list = response.data || []

          // 根据year和userId分组
          const map = new Map()
          for (const item of list) {
            const key = `${item.year}-${item.userId}`
            if (!map.has(key)) {
              map.set(key, {
                year: item.year,
                userId: item.userId,
                name: item.name
              })
            }
            const target = map.get(key)
            target[`${item.month}`] = item.goalMoney
            if (item.month == 13) target.total = item.goalMoney
          }
          let newList = []
          for (const [key, value] of map) {
            newList.push(value)
          }
          this.areaTargetList = newList

          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      getStatistics() {
        if (this.statLoading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          year: this.searchForm.year,
        }
        this.statLoading = true
        areaTargetStatistics(data).then(response => {
          const data = response.data || []
          this.statData = data

          this.statLoading = false
        }).catch(() => {
          this.statLoading = false
        })
      },

      getMonthTarget() {
        if (this.monthLoading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          month: this.searchForm.year_month,
        }
        this.monthLoading = true
        areaMonthTargets(data).then(response => {
          const data = response.data || []
          this.monthData = data

          this.monthLoading = false
        }).catch(() => {
          this.monthLoading = false
        })
      },

      getYjTarget() {
        if (this.loading2) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          year: this.searchForm2.year,
        }
        this.loading2 = true
        yjTargets(data).then(response => {
          const data = response.data || []
          this.dealerTarget = {}
          for (const item of data) {
            item.fileObj = item.file ? JSON.parse(item.file) : {}
            if (item.year  == this.searchForm2.year) {
              this.dealerTarget = { ...item }
            }
          }
          this.dealerTargetList = data

          this.loading2 = false
        }).catch(() => {
          this.loading2 = false
        })
      },

      getYjContract() {
        if (this.loading3) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        const data = {
          page: this.page3.currentPage,
          limit: this.page3.pageSize,
          year: this.searchForm2.year,
          search: this.searchForm2.search
        }
        this.loading3 = true
        yjContracts(data).then(response => {
          const data = response.data || []
          for (const item of data) {
            if (item.imgs) {
              item.imgs = JSON.parse(decodeURIComponent(item.imgs))
            }
            if (item.files) {
              item.files = JSON.parse(decodeURIComponent(item.files))
            }
          }
          this.dealerContractList = data
          this.page3.total = response.total

          this.loading3 = false
        }).catch(() => {
          this.loading3 = false
        })
      },
      handleSizeChange3(val) {
        this.page3.pageSize = val
        this.getYjContract()
      },
      handleCurrentChange3(val) {
        this.page3.currentPage = val
        this.getYjContract()
      },

      getYjMonth() {
        if (this.loading4) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }

        const year_month = this.searchForm2.year_month.split('-')
        const data = {
          page: this.page4.currentPage,
          limit: this.page4.pageSize,
          year: year_month[0],
          month: year_month[1] ? year_month[1] * 1 : '',
          search: this.searchForm2.search2
        }
        this.loading4 = true
        yjMonth(data).then(response => {
          const data = response.data || []
          this.yjMonthList = data
          this.page4.total = response.total

          this.loading4 = false
        }).catch(() => {
          this.loading4 = false
        })
      },
      handleSizeChange4(val) {
        this.page4.pageSize = val
        this.getYjMonth()
      },
      handleCurrentChange4(val) {
        this.page4.currentPage = val
        this.getYjMonth()
      },


      rowClassName({
        row,
        rowIndex
      }) {
        // 合计行，则返回CSS类名
        if (row.name === '合计') {
          return 'fixed-row';
        }
        return ''
      },
      cellClassName({
        row, column, rowIndex, columnIndex
      }) {
        // console.log(row, column, rowIndex, columnIndex)
        if (row.name === '合计') {
          return ''
        }
        // 定义分组映射关系
        const cellClassMap = {
          'custom-cell-1': ['group1', 'sumBalance', 'yearBalance', 'yearTargetMoney', 'sumTargetMoney', 'yearMoney', 'sumPct', 'yearPct', 'yearXd'],
          'custom-cell-2': ['group2', 'yearCyj', 'yearCyjXd', 'yearYj'],
          'custom-cell-3': ['group3', 'monthBalance', 'monthTargetMoney', 'monthMoney', 'monthPct', 'monthXd'],
          'custom-cell-4': ['group4', 'monthCyj', 'monthCyjXd', 'monthYj'],
        }
        let result = ''
        // 查找匹配的样式类
        for (const [className, properties] of Object.entries(cellClassMap)) {
          if (properties.includes(column.property)) {
            result = className;
            break
          }
        }
        return result;
      },

      showDetail(row, column) {
        this.orderCurrentPage = 1
        this.orderViewTitle = ''
        this.orderSearchForm = {}
        this.orderList = []
        this.orderTotal = 0
        this.orderVisible = true
        this.orderSearchForm = {
          year: this.searchForm.year,
          month: null,
          name: row.name,
          type: column.property,
          label: column.label,
        }
        this.getOrders()
      },
      showDetail2(row, column) {
        this.orderCurrentPage = 1
        this.orderViewTitle = ''
        this.orderList = []
        this.orderTotal = 0
        this.orderSearchForm = {
          year: null,
          month: this.searchForm.year_month,
          name: row.name,
          type: column.property,
          label: column.label,
        }
        this.orderVisible = true
        this.getOrders2()
      },

      getOrders() {
        const data = {
          page: this.orderCurrentPage,
          limit: this.orderPageSize,
          year: this.orderSearchForm.year,
          name: this.orderSearchForm.name,
          type: this.orderSearchForm.type,
        }
        this.orderLoading = true
        areaTargetStatisticDetail(data).then(response => {
          this.orderList = response.data || []
          this.orderLoading = false
          this.orderTotal = response.total || 0
          this.orderViewTitle = this.orderSearchForm.name + ' (' + this.orderSearchForm.label + ') - ' + '订单列表 (共 ' + this.orderTotal + ' 单)'
        }).catch(() => {
          this.orderLoading = false
        })
      },

      getOrders2() {
        const data = {
          page: this.orderCurrentPage,
          limit: this.orderPageSize,
          month: this.orderSearchForm.month,
          name: this.orderSearchForm.name,
          type: this.orderSearchForm.type,
        }
        this.orderLoading = true
        areaMonthTargetDetail(data).then(response => {
          this.orderList = response.data || []
          this.orderLoading = false
          this.orderTotal = response.total || 0
          this.orderViewTitle = this.orderSearchForm.name + ' (' + this.orderSearchForm.label + ') - ' + '订单列表 (共 ' + this.orderTotal + ' 单)'
        }).catch(() => {
          this.orderLoading = false
        })
      },

      handleOrderSizeChange(val) {
        this.orderPageSize = val
        this.orderSearchForm.month ? this.getOrders2() : this.getOrders()
      },
      handleOrderCurrentChange(val) {
        this.orderCurrentPage = val
        this.orderSearchForm.month ? this.getOrders2() : this.getOrders()
      },

      addData() {
        this.formData.userId = null
        this.formData.type = 'add'
        this.dialogTitle = `添加区域经理${this.searchForm.year}年度业绩目标`
        this.dialogVisible = true

        this.$nextTick(() => {
          this.resetForm('editForm')

          this.formData.name = ''
          this.formData.jsonStr = ''
          let jsonForm = {}
          for (const month of this.monthList) {
            jsonForm[month] = '0'
          }
          this.formData.jsonForm = jsonForm
          this.formData.year = this.searchForm.year
        })
      },

      editData(row) {
        this.formData.userId = row.userId
        this.formData.name = row.name
        this.formData.jsonStr = row.jsonStr
        let jsonForm = {}
        for (const month of this.monthList) {
          jsonForm[month] = row[month]
        }
        this.formData.jsonForm = jsonForm
        this.formData.year = row.year

        this.formData.type = 'edit'
        this.dialogTitle = `编辑区域经理${this.searchForm.year}年度业绩目标`
        this.dialogVisible = true
      },

      changeUser(val) {
        this.formData.userId = val.id
        this.formData.name = val.name
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            return false
          }
          this.formLoading = true
          const data = {
            year: this.formData.year,
            userId: this.formData.userId,
            name: this.formData.name,
            jsonStr: JSON.stringify(this.formData.jsonForm)
          }
          // 编辑
          if (this.formData.type === 'edit') {
            editAreaTarget(data).then(response => {
              this.dialogVisible = false
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.formLoading = false
              this.getData()
            }).catch(() => {
              this.formLoading = false
            })
            return
          }
          // 添加
          addAreaTarget(data).then(response => {
            this.dialogVisible = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.formLoading = false
            this.getData()
          }).catch(() => {
            this.formLoading = false
          })
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },

      delData(row) {
        this.$confirm(`确定删除${row.name}-${row.year}年度的业绩目标?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          delAreaTarget({ year: row.year, userId: row.userId }).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getData()
          })
        }).catch(() => {
        })
      },

      // ---------- 以下为经销商业绩目标配置相关方法 ----------------
      addData2() {
        if (!this.dealerList || this.dealerList.length == 0) return
        this.formData2.type = 'add'
        this.dialogTitle2 = `添加${this.searchForm.year}年度经销商业绩月度目标比例配置`
        this.dialogVisible2 = true

        this.$nextTick(() => {
          this.resetForm2('editForm2')

          let jsonForm = {}
          for (const month of this.monthList) {
            jsonForm['ratio' + month] = '0'
          }
          this.formData2.jsonForm = jsonForm
          this.formData2.year = this.searchForm2.year
        })
      },

      editData2(row) {
        if (!this.dealerList || this.dealerList.length == 0) return
        let jsonForm = {}
        for (const month of this.monthList) {
          jsonForm['ratio' + month] = row['ratio' + month] * 100
        }
        this.formData2.jsonForm = jsonForm
        this.formData2.id = row.id
        this.formData2.year = row.year
        this.formData2.file = row.file ? JSON.parse(row.file) : {}

        this.formData2.type = 'edit'
        this.dialogTitle2 = `编辑${this.searchForm.year}年度经销商业绩月度目标比例配置`
        this.dialogVisible2 = true
      },

      changeFile(val) {
        // console.log(val)
        this.formData2.fileId = val.id
        if (Array.isArray(val) && val.length > 0) {
          val.forEach(item => {
            this.formData2.file = {
              id: item.id,
              name: item.name,
              url: item.url
            }
          });
        } else {
          this.formData2.file = {}
        }
      },

      submitForm2(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            return false
          }
          let jsonForm = {}
          // 循环jsonForm，将key以ratio开头，value除以100，重新赋值给jsonForm
          for (const key in this.formData2.jsonForm) {
            if (key.startsWith('ratio')) {
              jsonForm[key] = this.formData2.jsonForm[key] / 100
            }
          }
          this.formLoading2 = true
          const data = {
            id: this.formData2.id,
            year: this.formData2.year,
            file: JSON.stringify(this.formData2.file),
            ...jsonForm
          }
          // 编辑
          if (this.formData2.type === 'edit') {
            editYjTarget(data).then(response => {
              this.dialogVisible2 = false
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.formLoading2 = false
              this.getYjTarget()
            }).catch(() => {
              this.formLoading2 = false
            })
            return
          }
          // 添加
          addYjTarget(data).then(response => {
            this.dialogVisible2 = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.formLoading2 = false
            this.getYjTarget()
          }).catch(() => {
            this.formLoading2 = false
          })
        })
      },
      resetForm2(formName) {
        this.$refs[formName].resetFields()
      },

      delData2(row) {
        this.$confirm(`确定删除${row.year}年度的业绩月度目标比例配置?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          delYjTarget({ id: row.id }).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getYjTarget()
          })
        }).catch(() => {
        })
      },

      // ---------- 以下为经销商业绩合同相关方法 ----------------
      addData3() {
        if (!this.dealerList || this.dealerList.length == 0) return
        this.formData3 = {
          type: 'add',
          target: 0,
          remark: ''
        }
        this.dialogTitle3 = `添加${this.searchForm2.year}年度经销商合同`
        this.dialogVisible3 = true

        this.$nextTick(() => {
          this.resetForm3('editForm3')
          this.formData3.year = this.searchForm2.year
        })
      },

      editData3(row) {
        if (!this.dealerList || this.dealerList.length == 0) return
        this.formData3 = { ...row }

        this.formData3.type = 'edit'
        this.dialogTitle3 = `编辑${this.searchForm2.year}年度经销商合同`
        this.dialogVisible3 = true
      },

      submitForm3(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            return false
          }
          this.formLoading3 = true
          const data = {
            id: this.formData3.id,
            year: this.formData3.year,
            dealerId: this.formData3.dealerId,
            target: this.formData3.target,
            imgs: encodeURIComponent(JSON.stringify(this.formData3.imgs || [])),
            files: encodeURIComponent(JSON.stringify(this.formData3.files || [])),
            remark: this.formData3.remark
          }
          // 编辑
          if (this.formData3.type === 'edit') {
            editYjContract(data).then(response => {
              this.dialogVisible3 = false
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.formLoading3 = false
              this.getYjContract()
            }).catch(() => {
              this.formLoading3 = false
            })
            return
          }
          // 添加
          addYjContract(data).then(response => {
            this.dialogVisible3 = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.formLoading3 = false
            this.getYjContract()
          }).catch(() => {
            this.formLoading3 = false
          })
        })
      },
      resetForm3(formName) {
        this.$refs[formName].resetFields()
      },

      delData3(row) {
        this.$confirm(`确定删除${row.dealerName}-${row.year}年度的合同?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          delYjContract({ id: row.id }).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getYjContract()
          })
        }).catch(() => {
        })
      },

      multilChangeFile(val) {
        // console.log(val)
        let files = []
        if (Array.isArray(val) && val.length > 0) {
          val.forEach(item => {
            files.push({
              id: item.id,
              name: item.name,
              url: item.url
            });
          });
        }
        this.formData3.files = files
      },
      multilChangeImg(val) {
        // console.log(val)
        let imgs = []
        if (Array.isArray(val) && val.length > 0) {
          val.forEach(item => {
            imgs.push({
              id: item.id,
              url: item.url
            });
          });
        }
        this.formData3.imgs = imgs
      },

      showImgOrFile(type, row) {
        // 查看图片
        if (type === 'img' && row.imgs && row.imgs.length > 0) {
          this.showImgViewer = true
          this.viewImgUrls = row.imgs.map(item => item.url)
        }
        // 文件下载
        else if (type === 'file' && row.files && row.files.length > 0) {
          // console.log(row.files)
          for (const item of row.files) {
            if (item && item.url) {
              window.open(item.url, '_blank')
            }
          }
        }
      },

      downFile(file) {
        if (file && file.url) {
          window.open(file.url, '_blank')
        }
      },

    }
  }
</script>

<style>
  .el-table__footer-wrapper td {
    background: #ecf5ff !important;
  }

  .el-table .custom-cell-1 {
    background-color: #f0f9eb;
  }
  .el-table .custom-cell-2 {
    background-color: #fdf6ec;
  }
  .el-table .custom-cell-3 {
    background-color: #f0fefe;
  }
  .el-table .custom-cell-4 {
    background-color: #fef0f0;
  }

  .el-table__body .fixed-row {
    position: sticky;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #ecf5ff;
  }
  .el-table__body .fixed-row td {
    border-top: 1px solid #EBEEF5;
  }

  .popover-custom .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
  .popover-custom .el-checkbox-group .el-checkbox {
    margin-bottom: 4px;
  }
</style>

<style lang="scss" scoped>
  .see-text {
    cursor: pointer;
    color: #409EFF;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
